import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { uuidv4 } from '../../../utils/utility';
import { fileHandlerUrl } from '../../../utils/consts/server';
import { ChevronDownIcon, PhotoGalleryIcon } from '~svg';
import './sliderGallery.scss';
const SliderGallery = ({
  slidesList = [],
  language = { name: 'en', direction: 'ltr' },
  alt = 'hotel room',
  imageVariant = 'w-100 default-border-radius-small',
  width = 256,
  height = 256,
  formatMessage = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const positionStart = () => {
    let start = language.direction === 'ltr' ? 'left-0' : 'right-0';
    return start;
  };
  return (
    <div className="w-100 position-relative slider-gallery-container">
      <ul
        className={`w-100 d-flex flex-wrap align-items-start justify-content-start list-unstyled bg-white gap-10 p-2 m-0 default-border-radius-small overflow-auto border ${
          isOpen ? 'h-100' : 'h-min-gallery'
        }`}
      >
        <h6 className="w-100 d-flex flex-wrap align-items-center border-bottom py-2 m-0 text-secondary">
          <PhotoGalleryIcon color="#00798c" variant="svg-small" />
          <span className="mx-2">
            {formatMessage({ id: 'tour.tourimages' })}
          </span>
        </h6>
        {!!slidesList?.length ? (
          slidesList.map((slide, index) => {
            const slideId = uuidv4();
            return (
              <li
                key={slideId}
                id={slideId}
                className="w-slide-container d-flex align-items-center justify-content-center position-relative default-border-radius-small"
              >
                <img
                  src={`${fileHandlerUrl}/file/show/${slide}`}
                  alt={alt}
                  className={`${imageVariant}`}
                  width={width}
                  height={height}
                />
                <span
                  className={`d-flex align-items-center pt-1 justify-content-center border border-dark rounded-circle position-absolute top-0 m-2 bg-checkbox default-border-radius-small font-weight-bold index-size ${positionStart()}`}
                >
                  {index + 1}
                </span>
              </li>
            );
          })
        ) : (
          <li className="w-100 h-100 d-flex align-items-center justify-content-center">
            not Found
          </li>
        )}
      </ul>
      {slidesList?.length > 4 && (
        <div className="w-100 d-flex align-items-center justify-content-center position-absolute bottom-0 mb-2">
          <span
            className={`rounded-circle p-1 bg-secondary cursor-pointer transition-all ${
              isOpen ? 'rotate-180' : ''
            }`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <ChevronDownIcon size={32} color="#aaacaf" />
          </span>
        </div>
      )}
    </div>
  );
};
SliderGallery.propTypes = {
  slidesList: PropTypes.array,
  language: PropTypes.object,
  alt: PropTypes.string,
  imageVariant: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  formatMessage: PropTypes.func,
};
export default SliderGallery;
